import { isEmpty, filter, sortBy, each } from 'lodash-es'
import { api } from '@/api'
import to from '@/modules/await-to-js'

const state = {
  lastBscEventsCounters: {},
  lastLnsEventsCounters: {},
  lastRncEventsCounters: {}
}

export const getters = {
  lastBscEventsCounters: state => state.lastBscEventsCounters,
  gatewaysAlarmCount: state => {
    if (!isEmpty(state.lastBscEventsCounters)) return state.lastBscEventsCounters.alarmsCount
    else return -1
  },

  lastLnsEventsCounters: state => state.lastLnsEventsCounters,
  endDevicesAlarmCount: state => {
    if (!isEmpty(state.lastLnsEventsCounters)) return state.lastLnsEventsCounters.clusterAlarms
    else return -1
  },

  lastRncEventsCounters: state => state.lastRncEventsCounters,
  networkAlarmCount: state => {
    if (!isEmpty(state.lastRncEventsCounters)) return state.lastRncEventsCounters.gatewayAlarmsCount
    else return -1
  }
}

export const mutations = {
  setLastBscEventsCounters (state, lastBscEventsCounters) {
    // Remove empty customers
    lastBscEventsCounters.customers = filter(lastBscEventsCounters.customers, customer => !isEmpty(customer.customer))
    // Sort by customer name and fleet name
    lastBscEventsCounters.customers = sortBy(lastBscEventsCounters.customers, customer => customer.customer.name)
    each(lastBscEventsCounters.customers, customer => {
      if (customer.fleets) customer.fleets = sortBy(customer.fleets, fleet => fleet.fleet.name)
    })
    state.lastBscEventsCounters = lastBscEventsCounters
  },

  setLastLnsEventsCounters (state, lastLnsEventsCounters) {
    // Remove empty customers
    lastLnsEventsCounters.customers = filter(lastLnsEventsCounters.customers, customer => !isEmpty(customer.customer))
    // Sort by customer name and cluster name
    lastLnsEventsCounters.customers = sortBy(lastLnsEventsCounters.customers, customer => customer.customer.name)
    each(lastLnsEventsCounters.customers, customer => {
      if (customer.clusters) customer.clusters = sortBy(customer.clusters, cluster => cluster.cluster.name)
    })
    state.lastLnsEventsCounters = lastLnsEventsCounters
  },

  setLastRncEventsCounters (state, lastRncEventsCounters) {
    // Remove empty customers
    lastRncEventsCounters.customers = filter(lastRncEventsCounters.customers, customer => !isEmpty(customer.customer))
    // Sort by customer name and fleet name
    lastRncEventsCounters.customers = sortBy(lastRncEventsCounters.customers, customer => customer.customer.name)
    each(lastRncEventsCounters.customers, customer => {
      if (customer.fleets) customer.fleets = sortBy(customer.fleets, fleet => fleet.fleet.name)
    })
    state.lastRncEventsCounters = lastRncEventsCounters
  }
}

export const actions = {
  async getLastGatewayEventsCounters (context, options = {}) {
    let error, response
    [error, response] = await to(api.getCustomersLastEventsCounters(context.rootGetters.application), options)
    if (error || !response) return Promise.reject(error)

    context.commit('setLastBscEventsCounters', response.data)
    return Promise.resolve(response)
  },

  async getLastLnsEventsCounters (context, options = {}) {
    let error, response
    [error, response] = await to(api.getLnsCustomersLastEventsCounters(context.rootGetters.application), options)
    if (error || !response) return Promise.reject(error)

    context.commit('setLastLnsEventsCounters', response.data)
    return Promise.resolve(response)
  },

  async getRncGatewaysLastEventsCounters (context, options = {}) {
    let error, response
    [error, response] = await to(api.getRncCustomersLastEventsCounters(context.rootGetters.application), options)
    if (error || !response) return Promise.reject(error)

    context.commit('setLastRncEventsCounters', response.data)
    return Promise.resolve(response)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
